import React from 'react';
import { Shield, Calendar, Award } from 'lucide-react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const trustBadges = [
    { icon: Shield, label: 'Unabhängiger Vergleich' },
    { icon: Calendar, label: 'Aktuell: Januar 2026' },
    { icon: Award, label: 'Redaktionell geprüft' },
];

export const Hero = () => {
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section
            id="hero"
            className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden"
        >
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0">
                <img
                    src="/index-bg.jpg"
                    alt="Kräutertee Hintergrund"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/85 to-background" />
            </div>

            {/* Content */}
            <div ref={ref} className="section-container relative z-10">
                <div className="max-w-3xl mx-auto text-center">
                    {/* Hero Card */}
                    <div
                        className={`bg-card/90 backdrop-blur-sm rounded-2xl shadow-elevated p-8 md:p-12 ${
                            isVisible ? 'animate-fade-in-up' : 'opacity-0'
                        }`}
                    >
                        {/* Main Heading */}
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
                            Die besten{' '}
                            <span className="text-primary">Detox Tees</span>{' '}
                            im Test 2026
                        </h1>

                        {/* Subheadline - Compliant version using "Eigenschaften" */}
                        <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
                            Vergleich 2026: Preis, Zutaten & Geschmack – ohne medizinische Heilversprechen.
                        </p>

                        {/* Trust Badges */}
                        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
                            {trustBadges.map((badge, index) => (
                                <div
                                    key={badge.label}
                                    className={`trust-badge ${
                                        isVisible
                                            ? `animate-fade-in-up`
                                            : 'opacity-0'
                                    }`}
                                    style={{ animationDelay: `${0.2 + index * 0.1}s` }}
                                >
                                    <badge.icon className="h-4 w-4" />
                                    <span>{badge.label}</span>
                                </div>
                            ))}
                        </div>

                        {/* CTA Button */}
                        <div
                            className={`mt-8 ${
                                isVisible ? 'animate-fade-in-up' : 'opacity-0'
                            }`}
                            style={{ animationDelay: '0.5s' }}
                        >
                            <a
                                href="#vergleich"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document
                                        .querySelector('#vergleich')
                                        ?.scrollIntoView({ behavior: 'smooth' });
                                }}
                                className="btn-cta inline-flex"
                            >
                                Zum Vergleich
                                <svg
                                    className="w-4 h-4 ml-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 14l-7 7m0 0l-7-7m7 7V3"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent z-10" />
        </section>
    );
};
